import * as amplitude from "@amplitude/analytics-browser";

export const trackABTestConversion = (
  flagKey: string,
  variant: string,
  eventName: string,
  props: Record<string, any>,
): void => {
  amplitude.track(eventName, {
    experiment_variant: variant,
    flag_key: flagKey,
    ...props,
  });
};

export const getAnonUser = () => {
  return {
    device_id: getOrCreateDeviceId(),
    country: getCountry(),
    language: getLanguage(),
    platform: getPlatform(),
    user_properties: {
      is_anonymous: true,
      browser: getBrowser(),
      screen_resolution: getScreenResolution(),
      timezone: getTimezone(),
    },
  };
};

const getCountry = () => {
  return navigator.language.split("-")[1] || "US";
};

const getLanguage = () => {
  return navigator.language || "en";
};

const getPlatform = () => {
  return navigator.platform || "unknown";
};

const getBrowser = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes("Chrome")) return "Chrome";
  if (userAgent.includes("Firefox")) return "Firefox";
  if (userAgent.includes("Safari")) return "Safari";
  if (userAgent.includes("Edge")) return "Edge";
  return "Unknown";
};

const getScreenResolution = () => {
  return `${screen.width}x${screen.height}`;
};

const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const getOrCreateDeviceId = () => {
  let deviceId = localStorage.getItem("amplitude_device_id");

  if (!deviceId) {
    deviceId =
      "device_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
    localStorage.setItem("amplitude_device_id", deviceId);
  }

  return deviceId;
};
